import { render, staticRenderFns } from "./PaginationSearchButton.vue?vue&type=template&id=2ec2751e&scoped=true&"
import script from "./PaginationSearchButton.vue?vue&type=script&lang=ts&"
export * from "./PaginationSearchButton.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationSearchButton.vue?vue&type=style&index=0&id=2ec2751e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2751e",
  null
  
)

export default component.exports